import { Button } from '@mui/material';
import AccountBalanceRounded from '@mui/icons-material/AccountBalanceRounded';
import { Link as RouterLink, useNavigate } from 'react-router';
import { EmptyState } from '@/components/EmptyState';
import { InstitutionSignupPage } from '@/platform/billing/InstitutionSignupPage';
import { useSession } from '@/platform/session';

/** /instituicoes/nova for someone whose profile is complete: coordinators may add one more. */
export function NewInstitutionPage() {
  const { role } = useSession();
  const navigate = useNavigate();
  if (role === 'coordinator') return <InstitutionSignupPage onBack={() => void navigate('/')} />;
  return (
    <EmptyState
      icon={AccountBalanceRounded}
      title="Sua conta já está ligada a uma instituição"
      description={
        role === 'admin'
          ? 'A administração cadastra instituições em Administração › Instituições e cursos.'
          : 'Para contratar o Lousa para outra instituição, entre com a conta Google de quem responde por ela.'
      }
      action={
        <Button component={RouterLink} to="/" variant="contained">
          Voltar ao início
        </Button>
      }
    />
  );
}
